// SvelteKit page configuration — disable SSR for SPA mode
export const prerender = false
export const ssr = false
export const trailingSlash = 'ignore'
